import React, { useEffect, useState, useRef } from "react";
import { Modal, Typography } from "antd";
import { getToken } from "../../utils";
const { Text } = Typography;

export default function AccountExpireAlertModal({ 
  expireDate = null, 
}) {
  const expireDateRef = useRef(expireDate);
  const STORE_KEY = 'account_expire_modal_token';

  // 如果是自动模式（没有传入 visible 属性），则使用原来的逻辑
  const [visible, setVisible] = useState(false);

  useEffect(() => {
      const token = getToken();
      if (token) {
        // 如果需要展示
        const storeage = localStorage.getItem(STORE_KEY);
        // 若不存在或者token不一致(重新登录了), 则显示
        if (!storeage || storeage !== token) {
          setVisible(true);
          localStorage.setItem(STORE_KEY, token);
        }
      }
  }, [])

  useEffect(() => {
    if (expireDate) {
      expireDateRef.current = expireDate;
    }
  }, [expireDate]);

  const handleOk = () => {
    setVisible(false);
  }
  return (
    <Modal
      title={`你的账户将在 ${expireDateRef.current} 到期`}
      visible={visible}
      okText="我知道了"
      onOk={() => handleOk()}
      closable={false}
      cancelButtonProps={{ style: { display: "none" } }} // 隐藏取消按钮
      maskClosable={false}   // 不能点击遮罩关闭（可按需）
    >
      <Text>
        到期后将无法登录，如还未完成学习，请及时与你的授课老师或校区管理员联系。
      </Text>
    </Modal>
  );
}
